import { NavLink } from 'react-router-dom';

const navItems = [
  {
    header: 'Adenocarcinoma',
    links: [
      { to: '/lung-cancer', label: 'Lung Cancer' },
      { to: '/colon-cancer', label: 'Colon Cancer' },
      { to: '/pancreatic-cancer', label: 'Pancreatic Cancer' },
      { to: '/breast-cancer', label: 'Breast Cancer' },
    ],
  },
  {
    header: 'Squamous Cell Carcinoma',
    links: [
      { to: '/esophagus-cancer', label: 'Esophagus Cancer' },
      { to: '/cervix-cancer', label: 'Cervix Cancer' },
    ],
  },
  {
    header: 'Basal Cell Carcinoma',
    links: [{ to: '/epidermis-cancer', label: 'Epidermis Cancer' }],
  },
  {
    header: 'Renal Cell Carcinoma',
    links: [{ to: '/kidney-cancer', label: 'Kidney Cancer' }],
  },
];

const utilLinks = [
  { to: '/profile', label: 'Profile' },
  { to: '/analytics', label: 'Analytics' },
  { to: '/scan-history', label: 'Scan History' },
  { to: '/settings', label: 'Settings & Privacy' },
  { to: '/help', label: 'Help Center' },
];

export default function Sidebar() {
  return (
    <nav id="sidebar" className="sidebar js-sidebar">
      <div className="sidebar-content" style={{ overflowY: 'auto', height: '100vh' }}>
        <NavLink className="sidebar-brand" to="/lung-cancer">
          <span className="align-middle">
            <img
              src={process.env.PUBLIC_URL + '/img/cancepro-logo.png'}
              style={{ height: 80, width: 80 }}
              alt="CancePro Logo"
            />
            {' '}CancePro
          </span>
        </NavLink>

        <ul className="sidebar-nav">
          {navItems.flatMap((section) => [
            <li key={`header-${section.header}`} className="sidebar-header">
              {section.header}
            </li>,
            ...section.links.map((link) => (
              <li key={link.to} className="sidebar-item">
                <NavLink
                  className={({ isActive }) =>
                    'sidebar-link' + (isActive ? ' active' : '')
                  }
                  to={link.to}
                >
                  <span className="align-middle">{link.label}</span>
                </NavLink>
              </li>
            )),
          ])}

          <li className="sidebar-header">Tools</li>
          {utilLinks.map((link) => (
            <li key={link.to} className="sidebar-item">
              <NavLink
                className={({ isActive }) =>
                  'sidebar-link' + (isActive ? ' active' : '')
                }
                to={link.to}
              >
                <span className="align-middle">{link.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
